module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/skor/skor.component.css
// module id = ./src/app/components/skor/skor.component.css
// module chunks = main